<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.875 4.9375C3.875 4.22656 4.44922 3.625 5.1875 3.625H7.8125C8.52344 3.625 9.125 4.22656 9.125 4.9375V7.5625C9.125 8.30078 8.52344 8.875 7.8125 8.875H5.1875C4.44922 8.875 3.875 8.30078 3.875 7.5625V4.9375ZM5.1875 7.5625H7.8125V4.9375H5.1875V7.5625ZM3.875 11.9375C3.875 11.2266 4.44922 10.625 5.1875 10.625H7.8125C8.52344 10.625 9.125 11.2266 9.125 11.9375V14.5625C9.125 15.3008 8.52344 15.875 7.8125 15.875H5.1875C4.44922 15.875 3.875 15.3008 3.875 14.5625V11.9375ZM5.1875 14.5625H7.8125V11.9375H5.1875V14.5625ZM14.8125 3.625C15.5234 3.625 16.125 4.22656 16.125 4.9375V7.5625C16.125 8.30078 15.5234 8.875 14.8125 8.875H12.1875C11.4492 8.875 10.875 8.30078 10.875 7.5625V4.9375C10.875 4.22656 11.4492 3.625 12.1875 3.625H14.8125ZM14.8125 4.9375H12.1875V7.5625H14.8125V4.9375ZM10.875 11.9375C10.875 11.2266 11.4492 10.625 12.1875 10.625H14.8125C15.5234 10.625 16.125 11.2266 16.125 11.9375V14.5625C16.125 15.3008 15.5234 15.875 14.8125 15.875H12.1875C11.4492 15.875 10.875 15.3008 10.875 14.5625V11.9375ZM12.1875 14.5625H14.8125V11.9375H12.1875V14.5625Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts" setup></script>

<style></style>
